<template>
  <div class="formparts select"
    @mouseenter="group1.visibleSelect = true"
    @mouseleave="group1.visibleSelect = false"
    :class="{ 'is-visible-list': group1.visibleSelect }"
    >
    <div class="select-label" role="select">{{data.selectedName}}<FontawesomeIcon :icon="group1.visibleSelect ? 'angle-up' : 'angle-down'" class="icn" /></div>
    <div v-if="group1.visibleSelect" class="select-option" ref="selectOption">
      <ul class="select-option-list">
        <li v-for="(list, index) in data.lists" :key="'select_box_' + index" class="ta-center" role="option">
          <label><input type="radio" :value="list.value" @click="data.select" name="group_rd_02">{{list.name}}</label>
        </li>
        <!-- <li v-for="(list, index) in attrs.lists" :key="index" class="ta-center" role="option">
          <label><input type="radio" :value="list.value" @click="select" name="group_rd_02">{{list.name}}</label>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import { SelectBox } from '@/logic/common/SelectBox'

export default defineComponent({
  name: 'SelectBox',
  props: {
    lists: {
      type: Array,
      default: []
    },
    selected: {
      type: Number,
      default: 0
    }
  },
  setup (props, context) {
    return { ...SelectBox(props, context) }
  }
})
</script>
